module.exports = __webpack_public_path__ + "img/info.3f03633a.svg";